import {
  GET_WASH_CENTRES_FAILURE,
  GET_WASH_CENTRES_REQUEST,
  GET_WASH_CENTRES_SUCCESS,
} from "./ActionType";

const initialState = {
  centres: [],
  loading: false,
  error: null,
};

export const washCentreReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WASH_CENTRES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_WASH_CENTRES_SUCCESS:
      return {
        ...state,
        centres: action.payload,
        loading: false,
        error: null,
      };
    case GET_WASH_CENTRES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


